import React from 'react';

import DaySchedule from 'components/DaySchedule';
import AfficheImage from 'components/Shared/AfficheImage';

import './FilmScheduleCard.scss';

function FilmScheduleCard({seancesByDay, onSeanceClick, goTo}) {
  return (
    <div className="FilmSchedule-container">
      <div
        className="FS-cover-container"
        onClick={() => goTo(`/cinema/${seancesByDay[0].cinema_id}/${seancesByDay[0].film_id}`)}
      >
        <AfficheImage affiche={seancesByDay[0].affiche} />
      </div>
      <DaySchedule seancesByDay={seancesByDay} onSeanceClick={s => onSeanceClick(s)} />
    </div>
  );
}

export default FilmScheduleCard;
